var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 19C7.45792 19 7.37017 18.9692 7.29967 18.9085C7.04917 18.6925 1.16992 13.5385 1.16992 7.375C1.16992 3.85975 4.02967 1 7.54492 1C11.0602 1 13.9199 3.85975 13.9199 7.375C13.9199 13.5385 8.04067 18.6925 7.79017 18.9085C7.71967 18.9692 7.63192 19 7.54492 19ZM7.54492 1.75C4.44292 1.75 1.91992 4.273 1.91992 7.375C1.91992 12.5065 6.43192 17.0695 7.54492 18.1165C8.65717 17.0688 13.1699 12.5005 13.1699 7.375C13.1699 4.273 10.6469 1.75 7.54492 1.75Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 11.5C5.27092 11.5 3.41992 9.64975 3.41992 7.375C3.41992 5.10025 5.27092 3.25 7.54492 3.25C9.81892 3.25 11.6699 5.10025 11.6699 7.375C11.6699 9.64975 9.81892 11.5 7.54492 11.5ZM7.54492 4C5.68417 4 4.16992 5.51425 4.16992 7.375C4.16992 9.23575 5.68417 10.75 7.54492 10.75C9.40567 10.75 10.9199 9.23575 10.9199 7.375C10.9199 5.51425 9.40567 4 7.54492 4Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 0.4
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54462 9.9997C7.33762 9.9997 7.16962 9.8317 7.16962 9.6247V7.23145L6.96262 7.33495C6.77737 7.42645 6.55237 7.35295 6.45937 7.16695C6.36712 6.9817 6.44212 6.7567 6.62737 6.6637L7.37737 6.2887C7.49287 6.2302 7.63162 6.23695 7.74187 6.3052C7.85212 6.37345 7.91962 6.49495 7.91962 6.6247V9.6247C7.91962 9.8317 7.75162 9.9997 7.54462 9.9997Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 0.4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29492 10H6.79492C6.58792 10 6.41992 9.832 6.41992 9.625C6.41992 9.418 6.58792 9.25 6.79492 9.25H8.29492C8.50192 9.25 8.66992 9.418 8.66992 9.625C8.66992 9.832 8.50192 10 8.29492 10Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 0.4
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.54492 5.5C7.752 5.5 7.91992 5.3321 7.91992 5.125C7.91992 4.91789 7.752 4.75 7.54492 4.75C7.33785 4.75 7.16992 4.91789 7.16992 5.125C7.16992 5.3321 7.33785 5.5 7.54492 5.5Z",
    fill: "#4E4E4E",
    stroke: "#4E4E4E",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddress);
export default __webpack_public_path__ + "static/media/address.42e7c0f3b57401924fdf3241804b3cfa.svg";
export { ForwardRef as ReactComponent };